import { FormSnapshotRequest } from '@assess/browser/api';

export const formSnapshotRequestSort = (a: FormSnapshotRequest, b: FormSnapshotRequest) => {
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
};
